<template>
    <el-row style="height:100%">
        <el-col :span="4" style="height: 100%; overflow-y: scroll;">
            <my-menu></my-menu>
        </el-col>
        <el-col :span="20" class="mainBody">
            <router-view />
        </el-col>
    </el-row>
</template>

<script>
    import MyMenu from '@/components/menu.vue'
    export default {
        components: {
            MyMenu
        },
    }
</script>

<style scoped>
    .mainBody {
        height: calc(100% - 92px);
    }
</style>